import type { EntityOfType } from '@cognitoforms/model.js';
import { hasValue } from '../../../util/helpers';
import type { Signature } from '@cognitoforms/types/server-types/model/signature';
import type VueModel from '@cognitoforms/vuemodel';

export interface SignatureMethods {
	validateRequiredSignature(this: EntityOfType<Signature>): string;
}

export const SignatureExtensions: SignatureMethods = {
	validateRequiredSignature(this: EntityOfType<Signature>) {
		// Store the model to use for localization when building the error message
		const model = this.meta.type.model;

		let error = '';

		if (!hasValue(this.Svg)) {
			error = model.getResource('required');
		}

		return error;
	}
};

export function applySignatureMetadataRules(model: VueModel): void {
	const type = model.types['Signature'];
	if (!type)
		return;

	type.addRule({
		name: 'Signature.SignedAt',
		execute(this: EntityOfType<Signature>) {
			if (this.Svg?.startsWith('data:'))
				this.SignedAt = new Date();
		},
		onChangeOf: type.getPaths('Svg')
	}).register();
}
